import { OliviaUserContext } from '@sa/olivia-contract';
import { ClientContext } from '@sa/bff-contract';
import jsSHA from 'jssha';

export interface StartMessageData {
  type: 0;
  query: StartMessageQuery;
}

export interface StartMessageQuery {
  text: string[];
  crn: string;
  user: {
    claimType: string;
    name: string;
  };
}

export const oliviaStartMessageFilter = (message: MessageEvent<StartMessageData>): boolean => {
  const type = message.data?.type;
  const text = message.data?.query?.text;
  const crn = message.data?.query?.crn;
  const claimType = message.data?.query?.user?.claimType;
  const name = message.data?.query?.user?.name;

  return type === 0 && crn && claimType && name && Array.isArray(text) ? true : false;
};

export const shaCrn = (crn: string, shaObj: jsSHA = new jsSHA('SHA-256', 'TEXT')): string => {
  shaObj.update(crn);
  return shaObj.getHash('HEX');
};

export const createOliviaUserContext = ({
  crn,
  user: { name },
  text: [claimQuestionId] = []
}: StartMessageQuery): OliviaUserContext => ({
  crn: shaCrn(crn),
  name,
  claimQuestionId
});

export const createClientContext = ({ user: { claimType } }: StartMessageQuery): ClientContext => ({ claimType });
